import React, { Component } from 'react'
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import styled from 'styled-components'
import ReactSelect from '../../ReactSelect';
import { defineCustomElements } from "@duetds/date-picker/dist/loader";
import DatePicker from '../../DatePicker';
import Moment from 'moment';

import { bindActionCreators } from 'redux'
import { actions as employeeActions } from '../../../actions/employee'
import { actions as maintenanceActions } from '../../../actions/maintenance'

import { UserRoles } from '../../../constants'
import { history } from '../../../store'

import "@duetds/date-picker/dist/collection/themes/default.css";

import AwardSummaryImage from '../../../images/award-summary.svg'
import AwardSummarySelectedImage from '../../../images/award-summary-selected.svg'
import AwardSummaryHoverImage from '../../../images/award-summary-hover.svg'
import DetailedTaxInformationImage from '../../../images/detailed-tax-information.svg'
import DetailedTaxInformationSelectedImage from '../../../images/detailed-tax-information-selected.svg'
import DetailedTaxInformationHoverImage from '../../../images/detailed-tax-information-hover.svg'
import TaxElectionsImage from '../../../images/tax-election.svg'
import TaxElectionsSelectedImage from '../../../images/tax-election-selected.svg'
import TaxElectionsHoverImage from '../../../images/tax-election-hover.svg'
import ViewByImage from '../../../images/view-by.svg'
import ViewBySelectedImage from '../../../images/view-by-selected.svg'
import ViewByHoverImage from '../../../images/view-by-hover.svg'
import VestElectionsImage from '../../../images/vest-elections.svg'
import VestElectionsSelectedImage from '../../../images/vest-elections-selected.svg'
import VestElectionsHoverImage from '../../../images/vest-elections-hover.svg'
import OptionsImage from '../../../images/options.svg'
import OptionsSelectedImage from '../../../images/options-selected.svg'
import OptionsHoverImage from '../../../images/options-hover.svg'


import employeeService from '../../../services/Employee.service'

import AwardSection from './AwardSection'
import ActionButton from './ActionButton'
import { Mobile, Desktop } from '../../../media'
import TaxElectionsDialog from '../common/TaxElectionsDialog'
import USFedRateDialog from '../common/USFedRateDialog'
import VestElectionsDialog from '../common/VestElectionsDialog'
import FractionalSharesDialog from '../dashboard/FractionalSharesDialog';
import ChangeTaxRateDialog from '../common/ChangeTaxRateDialog'
import CalendarSection from './CalendarSection'
import { logPageView, logPageLoadTime, logUserBrowserAndDevice } from '../../../utils/emfLogs';
import { Pages } from '../../../utils/loggerConstants';
import { pageLoadLogs } from '../../../utils/loggerUtils';

// Register Duet Date Picker
defineCustomElements(window);

const Wrapper = styled.div`
    display: block;

    // Mobile version.
    @media (max-width: 768px) {
        width: 100%;
        padding 0;
    }

    > div.filter {
        width: 930px;
        padding: 0;
        height: 112px;
        display: block;
        margin: 20px auto 20px auto;

        // Mobile version.
        @media (max-width: 768px) {
            height: 80px;
            width: 100%;
            padding: 0;
            margin: 24px 0 22px 0;
        }

        > div.left-area {
            width: 600px;
            display: inline-block;

            // Mobile version.
            @media (max-width: 768px) {
                width: auto;
                margin-left: 15px;
            }

            > .hint {
              font-family: Lato-Regular;
              font-size: 12px;
              margin: 0;
              color: #2B2B2B;
              line-height: 16px;
              margin: 0 0 4px 0;
              // Mobile
              @media (max-width: 768px) {
                width: 380px;
              }
            }

            > h1 {
                font-family: Lato-Light;
                font-size: 24px;
                font-weight: normal;

                color: #2B2B2B;
                line-height: 28px;
                margin: 0 0 7px 0;
            }

            > .custom-select.stock-awards-menu {
                width: 220px;
                margin-left: 0;

                .Select-value-label:before {
                    vertical-align: top;
                    content: "View by: ";
                }
            }
        }

        > ul.action-buttons {
            display: block;
            float: right;
            margin: 0;
            padding: 0;
            list-style-type: none;

            // Mobile version.
            @media (max-width: 768px) {
                margin-right: 16px;
            }

            > li.award-summary-menu {
                span[role=button] {
                    background-image: url(${AwardSummaryImage});
                }

                span[role=button]:hover {
                    background-image: url(${AwardSummaryHoverImage});
                }

                span[role=button]:active, span[role=button][aria-expanded=true] {
                    background-image: url(${AwardSummarySelectedImage});
                }

                div[role=menu] {
                    width: 192px;
                    height: auto;
                    top: 20px;
                }
            }

            > li.detailed-taxinformation-menu {
                span[role=button] {
                    background-image: url(${DetailedTaxInformationImage});
                }

                span[role=button]:hover {
                    background-image: url(${DetailedTaxInformationHoverImage});
                }

                span[role=button]:active, span[role=button][aria-expanded=true] {
                    background-image: url(${DetailedTaxInformationSelectedImage});
                }

                div[role=menu] {
                    width: 342px;
                    height: auto;
                    top: 20px;
                }
            }

            > li.vest-elections-menu {
                span[role=button] {
                    background-image: url(${VestElectionsImage});
                }

                span[role=button]:hover {
                    background-image: url(${VestElectionsHoverImage});
                }

                span[role=button]:active, span[role=button][aria-expanded=true] {
                    background-image: url(${VestElectionsSelectedImage});
                }

                div[role=menu] {
                    width: 192px;
                    height: auto;
                    top: 20px;
                }
            }

            > li.tax-elections-menu {
                span[role=button] {
                    background-image: url(${TaxElectionsImage});
                }

                span[role=button]:hover {
                    background-image: url(${TaxElectionsHoverImage});
                }

                span[role=button]:active, span[role=button][aria-expanded=true] {
                    background-image: url(${TaxElectionsSelectedImage});
                }
            }

            > li.view-by {
                span[role=button] {
                    background-image: url(${ViewByImage});
                }

                span[role=button]:hover {
                    background-image: url(${ViewByHoverImage});
                }

                span[role=button]:active, span[role=button][aria-expanded=true] {
                    background-image: url(${ViewBySelectedImage});
                }

                div[role=menu] {
                    width: 170px;
                    height: auto;
                    top: 20px;
                }
            }

            > li.options {
                span[role=button] {
                    background-image: url(${OptionsImage});
                }

                span[role=button]:hover {
                    background-image: url(${OptionsHoverImage});
                }

                span[role=button]:active, span[role=button][aria-expanded=true] {
                    background-image: url(${OptionsSelectedImage});
                }

                div[role=menu] {
                    width: 251px;
                    height: auto;
                    top: 20px;
                }
            }
        }
    }

    > div.date-interval {
        width: 960px;
        height: 83px;
        margin: 0 auto 23px auto;
        border-top: 1px solid #CCCCCC;

        // Mobile version.
        @media (max-width: 768px) {
            margin: 0 0 23px 0;
            height: 170px;
            width: 100%;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            padding-right: 15px;
            padding-left: 15px;
        }

        > div,start-date, > div.end-date {
            float: left;
            width: 210px;
            height: auto;

            // Mobile version.
            @media (max-width: 768px) {
                float: none;
                width: 100%;
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
            }

            > label {
                font-family: Lato-Regular;
                font-size: 12px;
                color: #666666;
                line-height: 16px;
                margin: 18px 0 9px 0;
                display: block;
                font-weight: bold;
            }

            div.duet-date {
              div.duet-date__input-wrapper {
                input {
                  border: 1px solid #CCCCCC;
                  border-radius: 2px;
                  padding: 10px 60px 10px 10px;
                  color: #808080;
                }
              }
              button.duet-date__toggle {
                z-index: auto;
              }
            }
        }

        > div.start-date {
            margin-right: 32px;
            margin-left: 15px;

            // Mobile version.
            @media (max-width: 768px) {
                margin-right: 15px;
                margin-left: 0;
            }
        }
    }
`

function getAwardSummaryMenuOptions(t) {
  var options = []
  options.push({ value: 0, label: t('StockAwards.AwardSummaryMenu.ViewPDFOption') })
  options.push({ value: 1, label: t('StockAwards.AwardSummaryMenu.DownloadExcelOption') })
  return options
}

function getDetailedTaxInformationMenuOptions(t) {
  var options = []
  options.push({ value: 2, label: t('StockAwards.DetailedTaxMenu.ViewPDFOption') })
  options.push({ value: 3, label: t('StockAwards.DetailedTaxMenu.DownloadExcelOption') })
  options.push({ value: 4, label: t('StockAwards.DetailedTaxMenu.ViewStatementOption') })
  return options
}

function getOptionsMenuOptions(t, fractional_mode, taxHide) {
  var options = getAwardSummaryMenuOptions(t)
  options = options.concat(getDetailedTaxInformationMenuOptions(t))
  if (fractional_mode){
    options.push({ value: 7, label: t('StockAwards.VestElectionTitle') })
    if (!taxHide){
      options.push({ value: 8, label: t('StockAwards.USFedRateTitle') })
    }
  }
  else{
    options.push({ value: 5, label: t('StockAwards.TaxElectionTitle') })
  }
  return options
}

class StockAwards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateMask: "YYYY-MM-DD",
      selectedOptionValue: 'award',
      awardsHidden: false,
      taxElectionsDialogVisible: false,
      usFedRateDialogVisible: false,
      vestElectionsDialogVisible: false,
      fractionalSharesDialogVisible: false,
      changeTaxRateDialogVisible: false,
      awardIdSelected: null,
      calendarYear: null,
      vest: null,
      startDate: props.employee_awards === null || props.employee_awards.length === 0 ? null : Moment(props.employee_awards[props.employee_awards.length - 1].awarded_date, 'YYYY-MM-DD').toDate(),
      endDate: props.employee_awards === null || props.employee_awards.length === 0 ? null : Moment(props.employee_awards[0].awarded_date, 'YYYY-MM-DD').toDate(),
    }
    Moment.locale(this.props.locale)
  }

  componentDidMount(){
    console.log("Mounted Stock Awards")
    logPageView(Pages.StockAwards)
    pageLoadLogs(navigator.userAgent, Pages.StockAwards)

    document.title = this.props.t('Header.Title') + " " + this.props.t('Navigation.StockAwardLabel')
    document.getElementById('main-h1').innerHTML = this.props.t('Header.Title') + " " + this.props.t('Navigation.StockAwardLabel')
  }

  onViewByChange = (selectedOption) => {

    if (selectedOption.value === 'award') {
      this.setState({
        selectedOptionValue: selectedOption.value,
        startDate: this.props.employee_awards === null || this.props.employee_awards.length === 0 ? null : Moment(this.props.employee_awards[this.props.employee_awards.length - 1].awarded_date, 'YYYY-MM-DD').toDate(),
        endDate: this.props.employee_awards === null || this.props.employee_awards.length === 0 ? null : Moment(this.props.employee_awards[0].awarded_date, 'YYYY-MM-DD').toDate(),
      });
    } else if (selectedOption.value === 'custom') {
      // Get the min and max dates from transactions and vests.
      const groups = employeeService.getTransactionsAndVestsByYear(this.props.employee_awards, null, null, false)
      var startDate = null
      var endDate = null
      if (groups.completed.length > 0) {
        startDate = groups.completed[0].transaction_date
        endDate = groups.completed[groups.completed.length - 1].transaction_date
      }
      if (groups.remaining.length > 0) {
        if (startDate == null) {
          startDate = groups.remaining[0].vest_date
        }
        endDate = groups.remaining[groups.remaining.length - 1].vest_date
      }
      this.setState({
        selectedOptionValue: selectedOption.value,
        startDate: startDate ? Moment(startDate, 'YYYY-MM-DD').toDate() : null,
        endDate: endDate ? Moment(endDate, 'YYYY-MM-DD').toDate() : null,
      });
    } else if (selectedOption.value === 'option') {
      const options = employeeService.getOptions(this.props.employee_awards)
      this.setState({
        selectedOptionValue: selectedOption.value,
        startDate: options === null || options.length === 0 ? null : Moment(options[options.length - 1].awarded_date, 'YYYY-MM-DD').toDate(),
        endDate: options === null || options.length === 0 ? null : Moment(options[0].awarded_date, 'YYYY-MM-DD').toDate(),
      });
    } else {
      this.setState({
        selectedOptionValue: selectedOption.value
      });
    }
  }

  onViewByChangeActionButton = (selectedValue) => {

    this.setState({ selectedOptionValue: selectedValue });
  }

  onOptionsChangeActionButton = (selectedValue) => {
    if (selectedValue === 7) {
      this.vestElectionsOnClick()
    }
    else if (selectedValue === 8) {
      this.usFedRateOnClick()
    }
    else if (selectedValue === 5) {
      this.taxElectionsOnClick()
    }
  }

  onSelectCalendarMenuItem = (selectedValue, year) => {

    this.props.actions.maintenance.checkMaintenaceStatus().then(isLive => {
      if (isLive) {
        if (selectedValue === 1) {
          this.props.actions.employee.getSummaryDocument(this.props.employee.id,
            this.state.selectedOptionValue,
            this.state.startDate ? Moment(this.state.startDate).format() : null,
            this.state.endDate ? Moment(this.state.endDate).format() : null,
            'pdf',
            null,
            this.state.selectedOptionValue === 'comp-year' ? 4 : null,
            this.state.selectedOptionValue === 'comp-year' ? 3 : null,
            year
          )
        }

        if (selectedValue === 2) {
          this.props.actions.employee.getSummaryDocument(
            this.props.employee.id,
            this.state.selectedOptionValue,
            this.state.startDate ? Moment(this.state.startDate).format() : null,
            this.state.endDate ? Moment(this.state.endDate).format() : null,
            'excel',
            null,
            this.state.selectedOptionValue === 'comp-year' ? 4 : null,
            this.state.selectedOptionValue === 'comp-year' ? 3 : null,
            year
          )
        }

        if (selectedValue === 3 || selectedValue === 4 || selectedValue === 6) {

          const report_type = selectedValue === 3 ? 'DETAIL_TAX_PDF' : (selectedValue === 4 ? 'DETAIL_TAX_EXCEL' : 'EMPLOYEE_EQUITY_PDF')
          let startDate = null
          let endDate = null

          if (this.state.selectedOptionValue === 'comp-year') {
            startDate = Moment(new Date(year, 3, 1)).format()
            endDate = Moment(new Date(parseInt(year) + 1, 4, 31)).endOf('day').format()
          } else if (this.state.selectedOptionValue === 'calendar-year') {
            startDate = Moment(new Date(year, 0, 1)).format()
            endDate = Moment(new Date(year, 11, 31)).endOf('day').format()
          } else {
            startDate = this.state.startDate ? Moment(this.state.startDate).format() : null
            endDate = this.state.endDate ? Moment(this.state.endDate).format() : null
          }

          this.props.actions.employee.getDetailedTaxDocument(report_type, this.props.employee.id, startDate, endDate)
        }
      } else {
        history.push("/maintenance", {})
      }
    })

    if (selectedValue === 5) {
      this.setState({
        calendarYear: year,
        taxElectionsDialogVisible: true
      })
    }
    else if (selectedValue === 7) {
      this.setState({
        calendarYear: year,
        vestElectionsDialogVisible: true
      })
    }
    else if (selectedValue === 8) {
      this.setState({
        calendarYear: year,
        usFedRateDialogVisible: true
      })
    }
  }

  awardSummaryChange = (selectedValue) => {
    const { selectedOptionValue } = this.state
    const format = selectedValue === 0 ? 'pdf' : 'excel'

    this.props.actions.maintenance.checkMaintenaceStatus().then(isLive => {
      if (isLive) {
        if (selectedOptionValue === 'comp-year' || selectedOptionValue === 'calendar-year') {
          this.props.actions.employee.getSummaryDocument(this.props.employee.id,
            selectedOptionValue,
            null, null, // do not use the date range
            format,
            null,
            this.state.selectedOptionValue === 'comp-year' ? 4 : null,
            this.state.selectedOptionValue === 'comp-year' ? 3 : null,
            null

          )
        } else {
          this.props.actions.employee.getSummaryDocument(this.props.employee.id,
            selectedOptionValue,
            this.state.startDate ? Moment(this.state.startDate).format() : null,
            this.state.endDate ? Moment(this.state.endDate).format() : null,
            format
          )
        }
      } else {
        history.push("/maintenance", {})
      }
    })


  }

  detailTaxInformationChange = (selectedValue) => {
    this.props.actions.maintenance.checkMaintenaceStatus().then(isLive => {
      if (isLive) {
        if (selectedValue === 2 || selectedValue === 3 || selectedValue === 4) {
          const report_type = selectedValue === 2 ? 'DETAIL_TAX_PDF' : (selectedValue === 3 ? 'DETAIL_TAX_EXCEL' : 'EMPLOYEE_EQUITY_PDF')
          const { selectedOptionValue } = this.state

          if (selectedOptionValue === 'calendar-year' || selectedOptionValue === 'comp-year') {
            this.props.actions.employee.getDetailedTaxDocument(report_type, this.props.employee.id)
          } else {
            const award_ids = []
            const start = Moment(this.state.startDate)
            const end = Moment(this.state.endDate)

            // Get the list of awards to request the report on
            this.props.employee_awards.forEach((award) =>{
              const awarded_date = Moment(award.awarded_date)
              if (award.transactions && award.transactions.length > 0 && awarded_date.isBetween(start, end,'day', "[]")) {
                award_ids.push(award.id)
              }
            })

            this.props.actions.employee.getDetailedTaxDocument(report_type, this.props.employee.id, null, null, award_ids)
          }
        }
      } else {
        history.push("/maintenance", {})
      }
    })
  }

  taxElectionsOnClick = (vest) => {
    this.setState({
      awardIdSelected: null,
      calendarYear: null,
      taxElectionsDialogVisible: true,
      vest: vest,
    })
  }

  taxElectionsOnCloseDialog = () => {
    this.setState({
      taxElectionsDialogVisible: false
    })
  }

  usFedRateOnClick = (vest) => {
    this.setState({
      awardIdSelected: null,
      calendarYear: null,
      usFedRateDialogVisible: true,
      vest: vest,
    })
  }

  usFedRateOnCloseDialog = () => {
    this.setState({
      usFedRateDialogVisible: false
    })
  }

  vestElectionsOnClick = (vest) => {
    this.setState({
      awardIdSelected: null,
      calendarYear: null,
      vestElectionsDialogVisible: true,
      vest: vest,
    })
  }

  vestElectionsOnCloseDialog = () => {
    this.setState({
      vestElectionsDialogVisible: false
    })
  }

  vestElectionsOnChangeDeliveryMethod = () => {
    this.setState({
      vestElectionsDialogVisible: false,
      fractionalSharesDialogVisible: true
    })
  }

  onCloseFractionalSharesDialog = () => {
    this.setState({ fractionalSharesDialogVisible: false })
  }

  taxElectionsOnChangeTaxPayment = () => {
    var award = null
    if (this.state.awardIdSelected) {
      award = employeeService.loadAward(this.props.employee.awards, this.state.awardIdSelected)
    }

    if (award && !award.has_us_sourcing_in) {
      this.setState({
        taxElectionsDialogVisible: false
      })
    } else {
      this.setState({
        taxElectionsDialogVisible: false,
        changeTaxRateDialogVisible: true
      })
    }

  }

  usFedRateOnChangeTaxPayment = () => {
    var award = null
    if (this.state.awardIdSelected) {
      award = employeeService.loadAward(this.props.employee.awards, this.state.awardIdSelected)
    }

    if (award && !award.has_us_sourcing_in) {
      this.setState({
        usFedRateDialogVisible: false
      })
    } else {
      this.setState({
        usFedRateDialogVisible: false,
        changeTaxRateDialogVisible: true
      })
    }

  }

  changeTaxRateOnCloseDialog = () => {
    this.setState({
      changeTaxRateDialogVisible: false
    })
  }

  onCloseDialogs = () => {
    this.setState({
      vestedAwardDetailsDialogVisible: false
    })
  }

  buttonClickHandler = (callback) => {
    this.setState({
      vestedAwardDetailsDialogVisible: true
    })
  }

  getViewByOptions = (t) => {
    var options = []
    options.push({ value: 'award', label: t('StockAwards.ViewByOptions.award') })
    options.push({ value: 'calendar-year', label: t('StockAwards.ViewByOptions.calendar-year') })
    options.push({ value: 'comp-year', label: t('StockAwards.ViewByOptions.comp-year') })
    options.push({ value: 'custom', label: t('StockAwards.ViewByOptions.custom') })

    if (employeeService.hasOptions(this.props.employee_awards)) {
      options.push({ value: 'option', label: t('StockAwards.ViewByOptions.option') })
    }
    return options
  }

  onStartDateChange = (date) => {
    this.setState({
      startDate: date.detail.valueAsDate ? date.detail.valueAsDate : ""
    });
  }

  onEndDateChange = (date) => {
    this.setState({
      endDate: date.detail.valueAsDate ? date.detail.valueAsDate : ""
    });
  }

  getDateFormatted = (date) => {
    if (date){
      var iso = date.toISOString().split('T')[0]
      return iso;
    }
    else {
      return "";
    }
  }

  onSelectAwardMenuItem = (key, awardId) => {
    if (key === 7) {
      // we need to verify if the award is valid

      this.setState({
        awardIdSelected: awardId,
        calendarYear: null,
        vestElectionsDialogVisible: true,
        vest: null
      })
    }
    else if (key === 8) {
      // we need to verify if the award is valid

      this.setState({
        awardIdSelected: awardId,
        calendarYear: null,
        usFedRateDialogVisible: true,
        vest: null
      })
    }
    else if (key === 5) {
      // we need to verify if the award is valid

      this.setState({
        awardIdSelected: awardId,
        calendarYear: null,
        taxElectionsDialogVisible: true,
        vest: null
      })
    }

    this.props.actions.maintenance.checkMaintenaceStatus().then(isLive => {
      if (isLive) {
        if (key === 1 || key === 2) {
          const award = employeeService.loadAward(this.props.employee.awards, awardId)
          const isOption = employeeService.isOption(award)
          const report_type = key === 1 ? 'pdf' : 'excel'
          this.props.actions.employee.getSummaryDocument(this.props.employee.id,
            isOption ? "option" : this.state.selectedOptionValue, null, null, report_type, awardId)
        }

        if (key === 3 || key === 4 || key === 6) {
          const report_type = key === 3 ? 'DETAIL_TAX_PDF' : (key === 4 ? 'DETAIL_TAX_EXCEL' : 'EMPLOYEE_EQUITY_PDF')
          this.props.actions.employee.getDetailedTaxDocument(report_type, this.props.employee.id, null, null, awardId)
        }
      } else {
        history.push("/maintenance", {})
      }
    })

  }

  onChangePaymentMethod = (vest) => {
    if (this.props.fractional_mode){
      this.vestElectionsOnClick(vest)
    }
    else {
      this.taxElectionsOnClick(vest)
    }
  }

  render() {
    const { t, employee } = this.props;
    const viewOnly = employeeService.hasRole(employee.roles, UserRoles.OVERRIDE_FED_TAX_VIEW) ? true : false
    const taxHide = employeeService.hasRole(employee.roles, UserRoles.OVERRIDE_FED_TAX_HIDE) ? true : false
    var taxEnable = employeeService.hasRole(employee.roles, UserRoles.OVERRIDE_FED_TAX_ENABLE) || viewOnly

    if (this.state.awardIdSelected) {
      const award = employeeService.loadAward(employee.awards, this.state.awardIdSelected)
      if (award && !award.has_us_sourcing_in) {
        taxEnable = false
      }
    }

    const ChevronImage = styled.img`
            width: 14px;
            height: 8px;
            margin-right: 8px;
        `
    const sections = []

    const dateLocalization = {
      buttonLabel: t('StockAwards.CalendarSection.ButtonLabel'),
      placeholder: this.state.dateMask,
      selectedDateMessage: t('StockAwards.CalendarSection.SelectedDateMessage'),
      prevMonthLabel: t('StockAwards.CalendarSection.PrevMonthLabel'),
      nextMonthLabel: t('StockAwards.CalendarSection.NextMonthLabel'),
      monthSelectLabel: t('StockAwards.CalendarSection.MonthSelectLabel'),
      yearSelectLabel: t('StockAwards.CalendarSection.YearSelectLabel'),
      closeLabel: t('StockAwards.CalendarSection.CloseLabel'),
      keyboardInstruction: t('StockAwards.CalendarSection.KeyboardInstruction'),
      calendarHeading: t('StockAwards.CalendarSection.CalendarHeading'),
      dayNames: Moment.weekdays(),
      monthNames: Moment.months(),
      monthNamesShort: Moment.monthsShort(),
      locale: this.props.locale,
    }

    if (this.state.selectedOptionValue === 'award') {
      const awards = employeeService.awardsByDate(this.props.employee_awards, Moment(this.state.startDate), Moment(this.state.endDate))
      const rsus = employeeService.getRSUs(awards, false)
      const options = employeeService.getOptions(awards, false)
      const fully_vested_awards = employeeService.getFullyVestedAwards(awards)

      sections.push({
        awards: rsus,
        title: t('StockAwards.ActiveRSUSectionTitle', { number_of_awards: rsus.length }),
        hidden: false,
        className: 'awards-view'
      })

      if (options && options.length > 0) {
        sections.push({
          awards: options,
          title: t('StockAwards.ActiveOptionSectionTitle', { number_of_awards: options.length }),
          hidden: false,
          className: 'options-view'
        })
      }

      if (fully_vested_awards && fully_vested_awards.length > 0) {
        sections.push({
          awards: fully_vested_awards,
          title: t('StockAwards.FullyVestedSectionTitle', { number_of_awards: fully_vested_awards.length }),
          hidden: true,
          className: 'fully-vested-view'
        })
      }
    } else if (this.state.selectedOptionValue === 'option') {
      const awards = employeeService.awardsByDate(this.props.employee_awards, Moment(this.state.startDate), Moment(this.state.endDate))
      const options = employeeService.getOptions(awards, false)
      const fully_vested_option = employeeService.getFullyVestedAwards(awards, true)
      if (options && options.length > 0) {
        sections.push({
          awards: options,
          title: t('StockAwards.ActiveOptionSectionTitle', { number_of_awards: options.length }),
          hidden: false,
          className: 'options-view'
        })
      }

      if (fully_vested_option && fully_vested_option.length > 0) {
        sections.push({
          awards: fully_vested_option,
          title: t('StockAwards.FullyVestedSectionTitle', { number_of_awards: fully_vested_option.length }),
          hidden: true,
          className: 'fully-vested-view'
        })
      }

    } else if (this.state.selectedOptionValue === 'calendar-year') {
      // Calendar Year applies to RSU only
      const rsus = employeeService.getRSUs(this.props.employee_awards)
      const groups = employeeService.getTransactionsAndVestsByYear(rsus)

      const firstYear = Object.keys(groups)[0];
      const lastYear = Object.keys(groups)[Object.keys(groups).length - 1];

      this.reportStartDate = Moment(new Date(firstYear, 0, 1)).format()
      this.reportEndDate = Moment(new Date(lastYear, 11, 31)).endOf('day').format()

      Object.keys(groups).reverse().forEach((key) => {
        sections.push(groups[key])
      })
    } else if (this.state.selectedOptionValue === 'comp-year') {
      // Comp year applies to RSU only
      const rsus = employeeService.getRSUs(this.props.employee_awards)
      const groups = employeeService.getTransactionsAndVestsByYear(rsus, null, null, true, 4, 3)

      const firstYear = Object.keys(groups)[0];
      const lastYear = Object.keys(groups)[Object.keys(groups).length - 1];

      this.reportStartDate = Moment(new Date(firstYear, 3, 1)).format()
      this.reportEndDate = Moment(new Date(parseInt(lastYear) + 1, 4, 31)).endOf('day').format()

      Object.keys(groups).reverse().forEach((key) => {
        sections.push(groups[key])
      })
    } else if (this.state.selectedOptionValue === 'custom') {
      // Comp year applies to RSU only
      const rsus = employeeService.getRSUs(this.props.employee_awards)
      const groups = employeeService.getTransactionsAndVestsByYear(rsus, this.state.startDate, this.state.endDate, false)
      sections.push(groups)
    }

    return (
      <Wrapper id="awards" className="stock-awards-container">
        <div className="filter">
          <div className="left-area">
            <Desktop>
            <p className="hint">{t('StockAwards.ViewAwardsByHint')}</p>
            </Desktop>
            <Mobile>
            <p className="hint">{t('StockAwards.ViewAwardsByHintMobile')}</p>
            </Mobile>
            <Desktop>
              <ReactSelect
                name="view-by"
                options={this.getViewByOptions(t)}
                value={this.getViewByOptions(t).find(opt => opt.value == this.state.selectedOptionValue)}
                onChange={this.onViewByChange}
                className="custom-select stock-awards-menu"
                isClearable={false}
                isSearchable={false} />
            </Desktop>
          </div>

          <Desktop>
            <ul className="action-buttons">
              <ActionButton className="award-summary-menu"
                options={getAwardSummaryMenuOptions(t)}
                onChange={this.awardSummaryChange}
                title={t('StockAwards.AwardSummaryMenu.Title')} />
              <ActionButton className="detailed-taxinformation-menu"
                options={getDetailedTaxInformationMenuOptions(t)}
                onChange={this.detailTaxInformationChange}
                title={t('StockAwards.DetailedTaxMenu.Title')} />
              {this.props.fractional_mode &&
                <ActionButton className="vest-elections-menu"
                  title={t('StockAwards.VestElectionTitle')}
                  onButtonClick={this.vestElectionsOnClick} />
              }
              {!this.props.fractional_mode &&
                <ActionButton className="tax-elections-menu"
                  title={t('StockAwards.TaxElectionTitle')}
                  onButtonClick={this.taxElectionsOnClick} />
              }
              {this.props.fractional_mode && !taxHide &&
                <ActionButton className="tax-elections-menu"
                  title={t('StockAwards.USFedRateTitle')}
                  onButtonClick={this.usFedRateOnClick} />
              }

            </ul>
          </Desktop>

          <Mobile>
            <ul className="action-buttons">
              <ActionButton className="view-by"
                selectedValue={this.state.selectedOptionValue}
                options={this.getViewByOptions(t)}
                title={t('StockAwards.ViewByTitle')}
                onChange={this.onViewByChangeActionButton} />
              <ActionButton className="options"
                options={getOptionsMenuOptions(t, this.props.fractional_mode, taxHide)}
                title={t('StockAwards.OptionsTitle')}
                onChange={this.onOptionsChangeActionButton} />
            </ul>
          </Mobile>
        </div>

        {(this.state.selectedOptionValue === 'custom' || this.state.selectedOptionValue === 'award' || this.state.selectedOptionValue === 'option') &&
          <div className="date-interval">
            <div className="start-date">
              <label htmlFor="start-date-input">{t('StockAwards.CalendarSection.StartDateLabel')} ({this.state.dateMask})</label>
              <DatePicker
                identifier="start-date-input"
                className="start-date-input"
                onChange={this.onStartDateChange}
                max={this.getDateFormatted(this.state.endDate)}
                value={this.getDateFormatted(this.state.startDate)}
                localization={dateLocalization}>
              </DatePicker>
            </div>
            <div className="end-date">
              <label htmlFor="end-date-input">{t('StockAwards.CalendarSection.EndDateLabel')} ({this.state.dateMask})</label>
              <DatePicker
                identifier="end-date-input"
                className="end-date-input"
                onChange={this.onEndDateChange}
                min={this.getDateFormatted(this.state.startDate)}
                value={this.getDateFormatted(this.state.endDate)}
                localization={dateLocalization}>
              </DatePicker>
            </div>
          </div>
        }

        {(this.state.selectedOptionValue === 'award' || this.state.selectedOptionValue === 'option') &&
          sections.map((el, index) => {
            return (
              <AwardSection
                key={index}
                awards={el.awards}
                sectionId={index}
                sectionTitle={el.title}
                onChangePaymentMethod={this.onChangePaymentMethod}
                onSelectAwardMenuItem={this.onSelectAwardMenuItem}
                className={el.className || 'awards-view'}
                hidden={el.hidden}
                taxHide={taxHide} />
            )
          })
        }

        {this.state.selectedOptionValue === 'calendar-year' &&
          <CalendarSection
            sections={sections}
            broker={this.props.broker}
            onSelectCalendarMenuItem={this.onSelectCalendarMenuItem}
            onChangePaymentMethod={this.onChangePaymentMethod}
            className="calendar-year-view"
            calendarType="calendar-year"
          />
        }

        {this.state.selectedOptionValue === 'comp-year' &&
          <CalendarSection sections={sections}
            broker={this.props.broker}
            startMonth={4}
            endMonth={3}
            onSelectCalendarMenuItem={this.onSelectCalendarMenuItem}
            onChangePaymentMethod={this.onChangePaymentMethod}
            className="calendar-year-view"
            calendarType="comp-year"
          />
        }

        {this.state.selectedOptionValue === 'custom' &&
          <CalendarSection sections={sections}
            broker={this.props.broker}
            isCustom={true}
            className="custom-calendar-year-view"
            calendarType="custom"
            onChangePaymentMethod={this.onChangePaymentMethod}
          />
        }
        <TaxElectionsDialog
          visible={this.state.taxElectionsDialogVisible}
          onChangeTaxPayment={this.taxElectionsOnChangeTaxPayment}
          onCloseDialog={this.taxElectionsOnCloseDialog}
          awardIdSelected={this.state.awardIdSelected}
          vest={this.state.vest}
          calendarYear={this.state.calendarYear}
        />
        <USFedRateDialog
          visible={this.state.usFedRateDialogVisible}
          onChangeTaxPayment={this.usFedRateOnChangeTaxPayment}
          onCloseDialog={this.usFedRateOnCloseDialog}
          awardIdSelected={this.state.awardIdSelected}
          vest={this.state.vest}
          calendarYear={this.state.calendarYear}
        />
        <VestElectionsDialog
          visible={this.state.vestElectionsDialogVisible}
          onChangeTaxPayment={this.taxElectionsOnChangeTaxPayment}
          onChangeDeliveryMethod={this.vestElectionsOnChangeDeliveryMethod}
          onCloseDialog={this.vestElectionsOnCloseDialog}
          awardIdSelected={this.state.awardIdSelected}
          vest={this.state.vest}
          calendarYear={this.state.calendarYear}
        />
        {taxEnable &&
          <ChangeTaxRateDialog
            visible={this.state.changeTaxRateDialogVisible}
            onCloseDialog={this.changeTaxRateOnCloseDialog}
            awardIdSelected={this.state.awardIdSelected}
            calendarYear={this.state.calendarYear}
            viewType={this.state.selectedOptionValue}
            viewOnly={viewOnly}
            key={Date.now()}
          />
        }
        <FractionalSharesDialog
          employee={employee}
          vests={employeeService.getUpcomingVests(employee.awards)}
          visible={this.state.fractionalSharesDialogVisible}
          onCloseDialog={this.onCloseFractionalSharesDialog}
        />



      </Wrapper>
    )
  }
}

const mapState = state => ({
  employee: state.employee,
  locale: state.employee.language,
  employee_awards: state.employee.awards,
  broker: state.employee.broker ? state.employee.broker.name : '',
  fractional_mode: state.static_content.fractional_mode
});

const mapDispatchToProps = dispatch => ({
  actions: {
    employee: bindActionCreators(employeeActions, dispatch),
    maintenance: bindActionCreators(maintenanceActions, dispatch),
  }
})

export default connect(mapState, mapDispatchToProps)(withTranslation("translations")(StockAwards));
